module.exports = __webpack_public_path__ + "static/media/key.56973d19.svg";